import type { IconTypes } from '@/modules/perseo-billing/ui/react/src/components/beta';
import {
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';

type DeliveryInfoTemplateProps = {
  deliveryIcon: IconTypes;
  title: string;
  children: React.ReactNode;
  additionalInfo?: React.ReactNode;
};

export const DeliveryInfoTemplate = ({
  deliveryIcon,
  title,
  children,
  additionalInfo
}: DeliveryInfoTemplateProps) => {
  return (
    <>
      <div
        tabIndex={0}
        className="co-flex co-p-8px lg:co-px-16px co-rounded-4px co-gap-16px co-bg-pds-neutral-100"
      >
        <Icon
          icon={deliveryIcon}
          width={32}
          height={32}
          className="co-min-w-32px co-min-h-32px lg:co-min-w-56px lg:co-min-h-56px"
        />
        <div className="co-flex co-flex-col co-gap-2px">
          <Typography color="primary" weight="semibold" leading="24px">
            {title}
          </Typography>
          {children}
        </div>
      </div>
      {additionalInfo}
    </>
  );
};

DeliveryInfoTemplate.displayName = 'DeliveryInfoTemplate';

export default DeliveryInfoTemplate;
